@if (show$ | async) {
  <div class="loading-scrim" data-cy="loading-scrim">
    <c11n-spinner size="large" colorMode="on-light"></c11n-spinner>
    <div class="c11n-text-lg-bold margin-top-3" [innerHtml]="loadingMessage"></div>
  </div>
}
